import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

/*
   estatebroker.AI · Coming Soon
   Página única de "EM BREVE" com barra dinâmica de carregando.
   O acesso ao painel continua via /auth/login (link discreto no rodapé).
*/
export default function ComingSoon() {
  const [progress, setProgress] = useState(4);

  // Barra "viva": pulsa entre 8% e 92% num loop suave.
  useEffect(() => {
    let raf;
    let dir = 1;
    let value = 8;
    const tick = () => {
      value += dir * 0.35;
      if (value >= 92) dir = -1;
      if (value <= 8) dir = 1;
      setProgress(value);
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div
      data-testid="coming-soon-page"
      className="min-h-screen w-full bg-[#0B0F14] text-white relative overflow-hidden flex flex-col"
    >
      {/* Fundo com grade sutil e halo azul */}
      <div className="pointer-events-none absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />
      <div className="pointer-events-none absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full"
        style={{
          background:
            "radial-gradient(closest-side, rgba(59,158,255,0.35), transparent)",
          filter: "blur(20px)",
        }}
      />
      <div className="pointer-events-none absolute -bottom-52 -left-40 w-[520px] h-[520px] rounded-full"
        style={{
          background:
            "radial-gradient(closest-side, rgba(59,158,255,0.22), transparent)",
          filter: "blur(20px)",
        }}
      />

      {/* Topo minimalista */}
      <header className="relative z-10 flex items-center justify-between px-6 sm:px-10 py-6">
        <div data-testid="brand-mark" className="text-xl sm:text-2xl font-semibold tracking-tight">
          estatebroker<span className="text-[#3B9EFF]">.AI</span>
        </div>
        <div className="text-[11px] uppercase tracking-[0.28em] text-stone-400 hidden sm:block">
          em construção
        </div>
      </header>

      {/* Corpo central */}
      <main className="relative z-10 flex-1 flex items-center justify-center px-6 sm:px-10">
        <div className="max-w-3xl w-full text-center">
          <div
            data-testid="coming-soon-eyebrow"
            className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/[0.04] px-4 py-1.5 text-xs uppercase tracking-[0.3em] text-stone-300 mb-8"
          >
            <span className="w-1.5 h-1.5 rounded-full bg-[#3B9EFF] animate-pulse" />
            Em breve
          </div>

          <h1
            data-testid="coming-soon-headline"
            className="text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight"
          >
            A maior transformação de <span className="text-[#3B9EFF]">IA</span> para
            corretores que vendem <span className="italic font-normal text-stone-100">de verdade</span>.
          </h1>

          <p className="mt-6 text-base sm:text-lg text-stone-400 max-w-2xl mx-auto">
            Estamos preparando algo grande. Uma nova forma de conduzir a sua carteira,
            direto pelo WhatsApp, com um parceiro de vendas que trabalha com você o dia inteiro.
          </p>

          {/* Barra de carregando dinâmica */}
          <div className="mt-14 max-w-xl mx-auto">
            <div className="flex items-center justify-between mb-2 text-[11px] uppercase tracking-[0.28em] text-stone-500">
              <span>ajustes finais</span>
              <span data-testid="progress-label" className="tabular-nums text-stone-300">
                {progress.toFixed(0)}%
              </span>
            </div>
            <div
              data-testid="coming-soon-progress"
              className="h-1.5 w-full bg-white/10 rounded-full overflow-hidden relative"
            >
              <div
                className="h-full bg-gradient-to-r from-[#3B9EFF] via-[#7BC0FF] to-[#3B9EFF] transition-[width] duration-100 ease-linear"
                style={{ width: `${progress}%` }}
              />
              {/* Shimmer overlay */}
              <div
                className="absolute inset-0 pointer-events-none"
                style={{
                  background:
                    "linear-gradient(90deg, transparent, rgba(255,255,255,0.15), transparent)",
                  backgroundSize: "200% 100%",
                  animation: "cs-shimmer 2.2s infinite linear",
                }}
              />
            </div>
            <div className="mt-3 text-[11px] text-stone-500">
              Novidades chegando. Se você já é corretor cadastrado, siga usando o WhatsApp normalmente.
            </div>
          </div>
        </div>
      </main>

      {/* Rodapé discreto com acesso ao painel */}
      <footer className="relative z-10 px-6 sm:px-10 py-6 flex items-center justify-between text-xs text-stone-500">
        <div>© {new Date().getFullYear()} estatebroker.AI</div>
        <Link
          to="/auth/login"
          data-testid="footer-login-link"
          className="hover:text-stone-200 transition-colors"
        >
          Acesso ao painel →
        </Link>
      </footer>

      {/* Keyframes locais */}
      <style>{`
        @keyframes cs-shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </div>
  );
}
